import React from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button} from "../Inputs";

interface DialogBoxProps {
    cancelLabel?: string;
    children?: React.ReactNode;
    handleCancel: () => void;
    handleSave: () => void;
    openDialog: boolean;
    saveLabel?: string;
    saveDisabled?: boolean;
    title: string;
}

export const DialogBox = ({
                              cancelLabel = "Cancel",
                              children,
                              handleCancel,
                              handleSave,
                              openDialog,
                              saveLabel = "Save",
                              saveDisabled = false,
                              title,
                          }: DialogBoxProps) => {


    const handleSaveClick = () => {
        handleSave();
    };

    const handleCancelClick = () => {
        handleCancel();
    };

    if (!openDialog) return null;

    return (
        <Dialog
            open={openDialog}
            aria-labelledby="edit-item"
            fullWidth
            maxWidth="sm">

            <DialogTitle id="edit-item" align={"center"}>
                {title}
            </DialogTitle>

            <DialogContent dividers>
                {children}
            </DialogContent>

            <DialogActions>
                {cancelLabel && (
                    <Button
                        name="btnCancelItem"
                        onClick={handleCancelClick}
                        label={cancelLabel}
                        isCollapsed
                    />
                )}

                <Button
                    name="btnSaveItem"
                    onClick={handleSaveClick}
                    label={saveLabel}
                    isCollapsed
                    isPrimary
                    disabled={saveDisabled}
                />
            </DialogActions>
        </Dialog>
    );
};

